import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const TableContainer = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const Thead = styled.thead`
  position: sticky;
  top: 0;
  background-color: white;
`

export const Headline = styled.tr`
  border-top: 2px solid ${colors.softGray};
`

export const Tr = styled.tr`
  border-top: ${({ $striped }) => ($striped ? 'none' : `1pt solid ${colors.softGray}`)};
  border-bottom: ${({ $striped }) => ($striped ? 'none' : `1pt solid ${colors.softGray}`)};
  height: 64px;

  &:last-child {
    border-bottom: none;
  }
`

export const Th = styled.th`
  text-align: left;
  color: ${({ $striped }) => ($striped ? 'none' : `${colors.strongGray}`)};
`

export const Tbody = styled.tbody`
  tr {
    &:nth-child(2n + 1) {
      background-color: ${({ $striped }) => ($striped ? `${colors.grayBackground}` : 'none')};
      color: ${({ $striped }) => ($striped ? `${colors.titleStrongBlack}` : 'none')};
    }
    border-bottom: none;
  }
`

export const Td = styled.td`
  padding: ${({ $striped }) => ($striped ? '0 32px 0 0' : 0)};
  margin-left: 10px;

  ${({ $applyBorderRadius }) => $applyBorderRadius && `
    &:first-child {
      border-radius: 12px 0 0 12px;
    }

    &:last-child {
      border-radius: 0 12px 12px 0;
    }
  `}
`
